import type { FC } from "react";
import { Box, Container, Row } from "@viagogo/core/ui";
import { Content } from "src/shared/components/content";
import { useWriteUrl } from "src/shared/utils/url-builder";
import {
  ContentDivider,
  LearnMoreLink,
  StyledImageCol,
  StyledTextBodyRow,
  TextWrapper,
} from "src/website-apps/responsive/stubhub-about-us/components/stubhub/styled-components";
import { StyledTitle } from "src/website-apps/shared/components/branding/styled-components";
import { Image, ImageSize } from "src/website-apps/shared/components/image";

interface JoinUsProps {
  readonly images: readonly string[];
}

export const JoinUs: FC<JoinUsProps> = ({ images }) => {
  const careersUrl = useWriteUrl("/careers");

  return (
    <>
      <ContentDivider />
      <TextWrapper>
        <Container>
          <Row>
            <StyledTitle>
              <Content id="cid$#1907011#" />
            </StyledTitle>
          </Row>
          <StyledTextBodyRow>
            <Content id="cid$#1907012#" raw />
          </StyledTextBodyRow>
          <StyledTextBodyRow>
            <LearnMoreLink url={careersUrl} newTab>
              <Content id="cid$#1907089#" raw />
            </LearnMoreLink>
          </StyledTextBodyRow>
          <Box pt={6}>
            <Row>
              {images.map((image, index) => (
                <StyledImageCol span={[12, 12, 12, 4]} key={index}>
                  <Image alt="Join Us" src={image} size={ImageSize.Rect8Col} />
                </StyledImageCol>
              ))}
            </Row>
          </Box>
        </Container>
      </TextWrapper>
    </>
  );
};
